import CryptoJS from 'crypto-js';

export const decryptText = (text: string, cipherKey: string) => {
  const decoded = CryptoJS.enc.Base64.parse(text).toString(CryptoJS.enc.Utf8);
  const decrypted = CryptoJS.AES.decrypt(decoded, cipherKey).toString(CryptoJS.enc.Utf8);
  return decrypted;
};
